// eslint-disable

import React, { useCallback, useMemo, useState, useEffect } from 'react'

import MaterialTableCustom from '../../../components/MaterialTableCustom'
import { useUpdatePurchaseOrder, useAddPurchaseOrder, useDeletePurchaseOrder } from '../../../hooks/queries'

const AllPurchaseOrdersTable = ({ data, refreshTableData }) => {
  const { mutateAsync: addPurchaseOrder } = useAddPurchaseOrder()
  const { mutateAsync: updatePurchaseOrder } = useUpdatePurchaseOrder()
  const { mutateAsync: deletePurchaseOrder } = useDeletePurchaseOrder()
  const [purchaseOrderData, setPurchaseOrderData] = useState(data)

  useEffect(() => {
    if (!data) return
    //MAPPING THROUGH THE DATA AND FORMATTING IT AS PER REQUIRED BY THE TABLE
    const new_data = data
      .sort((a, b) => new Date(a?.dateOfRecord) - new Date(b?.dateOfRecord))
      .map((d) => ({
        ...d,
        trackingNumber: d?.tracking?.trackingNumber,
        carrier: d?.tracking?.carrier,
        trackingStatus: d?.tracking?.status,
        openQuantity: (d?.orderedQuantity || 0) - (d?.receivedQuantity || 0), // ✅ computed here
      }))
    setPurchaseOrderData([...new_data])
  }, [data])

  // ✅ Helper: remove openQuantity before sending to backend
  const sanitizeData = (obj) => {
    const { openQuantity, ...clean } = obj
    return clean
  }

  const onRowAdd = useCallback(async (newData) => {
    await addPurchaseOrder(sanitizeData(newData))
    refreshTableData()
  }, [])

  const onRowUpdate = useCallback(async (newData) => {
    await updatePurchaseOrder(sanitizeData(newData))
    refreshTableData()
  }, [])

  const onRowDelete = useCallback(async (oldData) => {
    await deletePurchaseOrder({ id: oldData.id })
    refreshTableData()
  }, [])

  const columns = useMemo(
    () => [
      { title: 'Part Number', field: 'partNumber' },
      { title: 'PO Number', field: 'purchaseOrderNumber' },
      { title: 'PR Number', field: 'purchaseRequestNumber' },
      { title: 'Ordered Quantity', field: 'orderedQuantity' },
      { title: 'Received Quantity', field: 'receivedQuantity' },
      { title: 'Open Quantity', field: 'openQuantity', editable: 'never' },
      { title: 'PO Line Number', field: 'lineNumber' },
      { title: 'PO Line Status', field: 'lineStatus' },
      { title: 'Project Code', field: 'projectCode' },
      { title: 'Product Code', field: 'productCode' },
    ],
    [],
  )
  return (
    <MaterialTableCustom
      title={'PurchaseOrders Summary'}
      columns={columns}
      rowStyle={{
        fontSize: '12px',
        paddingTop: 0,
        paddingBottom: 0,
        height: 0,
      }}
      headerStyle={{
        marginTop: -5,
        paddingTop: 0,
        paddingBottom: 5,
      }}
      cellStyle={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        maxWidth: 135,
      }}
      data={purchaseOrderData}
      options={{
        filtering: false,
        search: true,
        paging: false,
        actionsColumnIndex: 10,
        maxBodyHeight: '600px',
      }}
      editable={{
        onRowAdd,
        onRowUpdate,
        onRowDelete,
      }}
    />
  )
}

export default AllPurchaseOrdersTable
